import { RemoteComponentLoader } from "./RemoteComponentLoader"
export default RemoteComponentLoader;